<template>
  <div class="content">
    <div class="notFound">
      <img :src="pageNotFound"
           class="notFound_icon icon--xxs">
      <h2 class="notFound_title">
        404
        <br> Ops! Página não encontrada
      </h2>
      <div class=" row no-gutters justify-content-center align-items-center notFound_text">
        Talvez esta página realmente não exista ou caso queira, você pode:
        <br> - Verificar se a URL foi digitada corretamente
        <br> - Escolher uma das opções abaixo: 
        <br> 
      </div>
      <div class="row no-gutters justify-content-center align-items-center"> 
        <div class="d-inline-block ml-3">
          <b-navbar-brand class="btn btn-sm btn-primary btn-add btnInicial"
                          type="button"
                          :to="{ name: 'rei_dashboard' }">
            Página Inicial
          </b-navbar-brand>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import broken from '@/assets/icons/broken-page.svg?sprite'
  import pageNotFound from '@/assets/icons/404.svg'

  export default {
    name: 'PageNotFound',
    data () {
      return {
        broken,
        pageNotFound,
        pageId: this.$route.params.id
      }
    },
  }
</script>

<style lang="scss">
  @import '../scss/_utilities/exports';

  .notFound {
    &_icon {
      height: pxToRem(260);
      width: 100%;
    }
    &_title {
      font-size: 28px;
      color: #074f7f;
      text-align: center;
      padding-top: 15px;
    }
    &_text {
      font-size: 18px;
      text-align: left;
      padding-top: 15px;
      padding-bottom: 30px;
    }
  }
  .btnInicial {
    height: 40px;
    width:135px;
    font-size: 16px;
    border-color: transparent;
    background-color: #074f7f
  }

</style>
